export class TextFilterValueConverter {
	toView(value: any, when: any, replaceWith: any) {
		return value.toString() === when ? replaceWith : value;
	}
}
